var _defs, _g, _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobSpectraShip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 706.65 706.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #d9faff;\n      }\n\n      .cls-2 {\n        fill: #b1e1e5;\n      }\n\n      .cls-3 {\n        fill: aqua;\n      }\n\n      .cls-4 {\n        fill: #ff88a4;\n      }\n\n      .cls-5 {\n        fill: #c9ecf2;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "564.35 412.79 529.34 418.05 456.47 418.05 456.47 356.03 564.35 372.23 564.35 412.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "578.55 288.39 245.4 332.02 62.4 405.5 507.77 405.5 578.55 288.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "502.59 417.49 99.01 417.49 61.91 405 505.51 405 502.59 417.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "413.98 445.56 226.41 436.27 226.41 425.63 413.98 416.34 413.98 445.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "568.54 450.77 393.62 447.57 323.15 404.7 508.39 404.7 568.54 450.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "314.4 358.02 245.4 331.02 502.4 259.94 617.4 247.02 578.99 288.67 314.4 358.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "245.4 331.02 61.65 405.65 204.4 405.65 579.4 289.02 245.4 331.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "575.12 459.63 422.23 456.76 393.15 447.09 568.03 450.77 575.12 459.63"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "293.65 404.65 204.65 405.65 578.65 289.65 293.65 404.65"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobSpectraShip);
export default __webpack_public_path__ + "static/media/mob-spectra-ship.2eedcf80e3bd463ad1e4d7092650e8cb.svg";
export { ForwardRef as ReactComponent };